import { render, staticRenderFns } from "./appointList.vue?vue&type=template&id=62ae6308&scoped=true"
import script from "./appointList.vue?vue&type=script&lang=js"
export * from "./appointList.vue?vue&type=script&lang=js"
import style0 from "./appointList.vue?vue&type=style&index=0&id=62ae6308&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae6308",
  null
  
)

export default component.exports